/* lp-zoom.js — product image zoom: the full-screen lightbox (all devices: tap to 2.4×, drag to pan,
   pinch, swipe between frames, arrows and Escape) and the desktop hover magnifier that waits out a
   650ms hover-intent delay. Ported 16 Sep 2026 from the prototype's LB/lbGestures/magnifier block
   (website/Leatherpress_Website_v4_branch2.html, "product image zoom"). Document-level and built
   once; the lightbox markup is created on first use. A gallery host tells it which frames belong
   together by implementing lpViews() → {list, i} (the collection shelf does; the product page will).
   CSS: the .magwrap/.maglens/.maghint/.lbox family in lp-tokens.css.

   30 Sep 2026, the way out of the photo viewer. Luke asked for "a clear back button" so shoppers are never
   stuck in it, and for the Inspire colour swatches inside it. Measured on the live site that day: the phone's
   back gesture and the browser's Back button LEFT THE PRODUCT PAGE with the viewer still open (nothing was
   added to the history), the only exit on screen was a faint unlabeled × where the cart icon usually sits,
   and tapping the photo zooms it rather than closing. So:
     - a labeled Back button at the top left; the × stays at the top right, with a ring so it reads as a button;
     - opening adds one history entry at the same address, so Back (the button, the gesture, Android's key)
       closes the viewer and leaves the shopper on the page; closing any other way takes that entry back out,
       so the next Back leaves the page exactly as it did before;
     - focus moves into the viewer, Tab stays inside it, and it goes back to the photo on close;
     - on Inspire, a strip of the colour swatches under the photo (see palette()). */
(function () {
  'use strict';
  if (window.__lpZoom) return; window.__lpZoom = true;
  var LB = { list: [], i: 0, z: 1, tx: 0, ty: 0, box: null, img: null, host: null, pal: null, opener: null, last: null, backing: false, repush: false };
  /* marks the history entry this page load added; a reload keeps history.state, and an entry left over from
     an earlier load must not be mistaken for the open viewer's */
  var TOKEN = 'lb' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  /* the photos fetched ahead (see fetchOne). Declared up here because restore(), below, opens the viewer while
     this file is still running, before anything further down has been assigned */
  var PICK_HOLD = 1500, PICKSEQ = 0, CHIPT = null;
  var AHEAD = { list: null, busy: false, got: {}, kept: [] };
  /* the photos fetched ahead stay held (the downloaded file, not decoded) until 12 newer ones replace them:
     a copy nothing holds may be dropped, and without the disk cache it was downloaded again (see lp-shelf.js KEEP_N) */
  var KEEP_N = 12;
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function isOpen() { return !!(LB.box && LB.box.classList.contains('open')); }
  function ensure() {
    if (LB.box) return;
    var box = document.createElement('div');
    box.className = 'lbox'; box.id = 'lbox'; box.tabIndex = -1;
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Product photos');
    box.innerHTML = '<button type="button" class="lbback" data-lb-close><span class="lbback__arrow" aria-hidden="true">&lsaquo;</span>Back</button>'
      + '<button type="button" class="lbclose" data-lb-close aria-label="Close photos">&times;</button>'
      + '<button type="button" class="lbnav prev" data-lb-nav="-1" aria-label="Previous photo">&lsaquo;</button>'
      + '<div class="lbstage" id="lbstage"><img class="lbimg" id="lbimg" alt=""></div>'
      + '<button type="button" class="lbnav next" data-lb-nav="1" aria-label="Next photo">&rsaquo;</button>'
      + '<div class="lbfoot">'
      +   '<div class="lbpal" id="lbpal" hidden><div class="lbpalname" id="lbpalname"></div>'
      +     '<div class="lbsw" id="lbsw" role="group" aria-label="Color"></div>'
      +     '<a class="lbgo" id="lbgo" hidden></a></div>'
      +   '<div class="lbcount" id="lbcount" aria-live="polite"></div>'
      + '</div>';
    document.body.appendChild(box);
    LB.box = box; LB.img = box.querySelector('#lbimg');
    box.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-lb-close]')) { close(); return; }
      var nav = t.closest('[data-lb-nav]'); if (nav) { lbNav(Number(nav.getAttribute('data-lb-nav'))); return; }
      var sw = t.closest('[data-lb-color]'); if (sw) { pickColor(Number(sw.getAttribute('data-lb-color'))); return; }
      if (t.closest('#lbgo')) { goColor(e); return; }
      if (t === box || t.id === 'lbstage') close();
    });
    /* the colour strip: a chip the mouse rests on (60ms) or a finger lands on starts its first photo (see warmColor) */
    box.addEventListener('pointerover', function (e) {
      var sw = stripChip(e); clearTimeout(CHIPT); if (!sw || e.pointerType !== 'mouse') return;
      CHIPT = setTimeout(function () { warmColor(Number(sw.getAttribute('data-lb-color'))); }, 60);
    });
    box.addEventListener('pointerout', function () { clearTimeout(CHIPT); });
    box.addEventListener('pointerdown', function (e) { var sw = stripChip(e); if (sw) warmColor(Number(sw.getAttribute('data-lb-color'))); });
    gestures();
  }
  function apply() { LB.img.style.transform = 'translate(' + LB.tx + 'px,' + LB.ty + 'px) scale(' + LB.z + ')'; LB.img.classList.toggle('zoomed', LB.z > 1); }
  function show(i) {
    var n = LB.list.length; if (!n) return;
    endWipe();
    LB.i = (i + n) % n; LB.z = 1; LB.tx = 0; LB.ty = 0;
    LB.img.src = LB.list[LB.i]; apply();
    AHEAD.got[LB.list[LB.i]] = 1;   /* the viewer's own image has it: the fetch-ahead never asks for it again */
    keepEntry();
    LB.box.querySelector('#lbcount').textContent = (LB.i + 1) + ' / ' + n;
    var showNav = n > 1;
    LB.box.querySelectorAll('.lbnav').forEach(function (b) { b.style.visibility = showNav ? 'visible' : 'hidden'; });
  }
  function lbNav(d) { show(LB.i + d); }
  /* host: the gallery the photos came from (lp-shelf / lp-pdp); opener: the photo to give focus back to;
     byKey: opened from the keyboard, so the Back button takes focus (a tap or click focuses the dialog itself,
     which draws no focus ring on a phone) */
  function open(list, i, host, opener, byKey) {
    ensure();
    list = (list || []).filter(Boolean); if (!list.length) return;
    var again = isOpen();
    LB.list = list; LB.host = host || null;
    if (!again) {
      var ae = document.activeElement;
      LB.opener = opener || (ae && ae !== document.body ? ae : null);
      LB.last = { list: list.slice(), i: i || 0, host: LB.host, opener: LB.opener };
      pushEntry(i || 0);   /* before the viewer paints, so the phone's swipe-back preview shows the page without it */
    }
    LB.box.classList.add('open'); document.body.style.overflow = 'hidden'; show(i || 0);
    aheadFrom(LB.list);   /* the photos either side follow once this one is on screen */
    palette(LB.host);
    label();
    if (!again) { var f = byKey ? LB.box.querySelector('.lbback') : LB.box; try { f.focus({ preventScroll: true }); } catch (e) { try { f.focus(); } catch (e2) {} } }
  }
  /* fromPop: the history entry is already gone (the shopper pressed Back) */
  function close(fromPop) {
    if (!isOpen()) return;
    endWipe();
    LB.box.classList.remove('open'); document.body.style.overflow = '';
    if (!fromPop && onEntry()) { LB.backing = true; try { history.back(); } catch (e) { LB.backing = false; } }
    focusBack();
  }
  window.lpLightbox = { open: open, close: close };

  /* ---- history: Back closes the viewer ----
     One same-address entry per opening, pushed inside the tap or click (Chrome's back button skips entries a
     page adds without a user gesture). No hash, so lp-shelf.js's #shelf- jump never fires. Horizon's
     scroll-container.js patches pushState to save the scroll position into the page's entry and restores it on
     popstate; measured compatible (the page stays where it was). */
  function onEntry() { var s = history.state; return !!(s && s.lpViewer === TOKEN); }
  /* the entry follows the photos: a reload reopens the colour and photo last shown, not the ones the viewer
     opened on (preview review, 30 Sep 2026). Debounced, and the same address, so nothing else notices. */
  var KEEPT = null;
  function keepEntry() {
    clearTimeout(KEEPT);
    KEEPT = setTimeout(function () {
      if (!isOpen() || !onEntry()) return;
      var s = history.state, copy = {};
      for (var k in s) { if (Object.prototype.hasOwnProperty.call(s, k)) copy[k] = s[k]; }
      copy.lpList = LB.list.slice(0, 40); copy.lpI = LB.i;
      try { history.replaceState(copy, ''); } catch (e) {}
    }, 400);
  }
  /* the entry also carries the photos, so a reload on it can put the viewer back (restore(), below) */
  function pushEntry(i) {
    if (LB.backing) {
      if (onEntry()) { LB.repush = true; return; }   /* reopened before the last close finished taking its entry out */
      LB.backing = false;
    }
    if (onEntry()) return;
    try { history.pushState({ lpViewer: TOKEN, lpList: LB.list.slice(0, 40), lpI: i || 0 }, ''); } catch (e) {}
  }
  window.addEventListener('popstate', function () {
    if (LB.backing) {   /* the entry a close took out, not the shopper pressing Back */
      LB.backing = false;
      if (LB.repush) { LB.repush = false; if (isOpen()) pushEntry(); }
      return;
    }
    if (isOpen() && !onEntry()) { close(true); return; }
    /* Forward after Back closed it: the photos come back, as Forward promises */
    if (!isOpen() && onEntry() && LB.last) {
      var L = LB.last, v = (L.host && L.host.isConnected && typeof L.host.lpViews === 'function') ? L.host.lpViews() : null;
      if (v && v.list && v.list.length) open(v.list, v.i, L.host, L.opener); else open(L.list, L.i, L.host, L.opener);
    }
  });
  /* a page restored from the back/forward cache must never come back with the viewer open and no entry under it */
  window.addEventListener('pageshow', function (e) { if (e.persisted && isOpen() && !onEntry()) close(true); });
  /* A reload while the viewer is open (or a phone reloading a tab it dropped from memory) lands on the viewer's
     own entry, left by the earlier load. Without this the viewer is gone and the next Back seems to do nothing
     (it only steps to the page's own entry at the same address). So the photos come back on that entry, and Back
     closes them as usual. Found by the review, 30 Sep 2026. */
  (function restore() {
    var s = history.state;
    if (!s || !s.lpViewer || s.lpViewer === TOKEN || !s.lpList || !s.lpList.length) return;
    var copy = {}; for (var k in s) { if (Object.prototype.hasOwnProperty.call(s, k)) copy[k] = s[k]; }
    copy.lpViewer = TOKEN;   /* now this load's entry: open() below adds none of its own */
    try { history.replaceState(copy, ''); } catch (e) { return; }
    open(s.lpList, s.lpI || 0, null, null, false);
  })();

  /* ---- focus: into the viewer on open, kept there by Tab, back to the photo on close ---- */
  function focusables() {
    return [].filter.call(LB.box.querySelectorAll('button, a[href]'), function (el) {
      return !el.closest('[hidden]') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
    });
  }
  function focusBack() {
    var el = LB.opener; LB.opener = null;
    /* the shelf redraws its stage when a colour is picked in the viewer; the photo now showing stands in */
    if (!el || !el.isConnected) { var h = LB.host; el = (h && h.isConnected) ? h.querySelector('.bstage img.zoomable, .magwrap .zoomable') : null; }
    if (!el) return;
    /* a photo is not focusable by itself: tabindex -1 lets it take focus without joining the Tab order */
    if (!el.hasAttribute('tabindex') && el.tabIndex < 0) { el.setAttribute('tabindex', '-1'); el.setAttribute('data-lb-focus', ''); }
    try { el.focus({ preventScroll: true }); } catch (e) {}
  }
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') lbNav(-1); else if (e.key === 'ArrowRight') lbNav(1);
    else if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) return;
      var k = f.indexOf(document.activeElement);
      if (e.shiftKey && k <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && (k === -1 || k === f.length - 1)) { e.preventDefault(); f[0].focus(); }
    }
  });
  function label() {
    var n = '', h = LB.host;
    if (LB.pal) n = LB.pal.colors[LB.pal.cur].n;
    else if (h && h.tagName === 'LP-SHELF' && h.colors && h.st) n = (h.colors[h.st.c] || {}).n || '';
    else if (h) { var t = h.querySelector('h1'); n = t ? t.textContent.trim() : ''; }
    LB.box.setAttribute('aria-label', n ? 'Photos of ' + n : 'Product photos');
  }

  /* ---- the colour strip (Inspire only: the one family whose shelf paints the page in its live colour) ----
     On the collection shelf the strip drives the shelf itself, so Back lands on the colour just picked, beside
     its add to bag. On an Inspire product page it swaps the photos to that colour and offers a link to that
     colour's page, on the same size; the other colours come from the collection page's own shelf data,
     fetched once on the first opening and kept for the visit. If anything is missing the strip simply does not
     appear and the viewer works as before. */
  function hasHex(c) { return !!(c && c.hex); }
  function handle(u) { var m = /\/products\/([^\/?#]+)/.exec(String(u || '')); return m ? m[1].toLowerCase() : ''; }
  function palette(host) {
    var wrap = LB.box.querySelector('#lbpal');
    LB.pal = null; wrap.hidden = true; LB.box.classList.remove('haspal');
    LB.box.querySelector('#lbcount').removeAttribute('data-name');
    if (!host) return;
    if (host.tagName === 'LP-SHELF') {
      var f = host.fam || {}, cs = host.colors || [];
      if (f.live === true && cs.length > 1 && cs.every(hasHex) && host.st && typeof host.pick === 'function' && typeof host.lpViews === 'function') {
        LB.pal = { kind: 'shelf', colors: cs, cur: host.st.c, home: host.st.c, homeList: null };
        buildPal();
      }
      return;
    }
    if (host.tagName === 'LP-PDP' && host.classList.contains('pdp-inspire')) {
      LB.box.classList.add('haspal');   /* keep the strip's room from the start, so the photo does not jump when it arrives */
      var homeList = LB.list.slice(), here = handle(location.pathname);
      siblings(host).then(function (d) {
        if (!isOpen() || LB.host !== host || LB.pal) return;
        var cs = (d && d.colors) || [], cur = -1;
        cs.some(function (c, i) { if (here && handle(c.url) === here) { cur = i; return true; } return false; });
        if (cur < 0 || cs.length < 2 || !cs.every(hasHex)) { LB.box.classList.remove('haspal'); return; }
        LB.pal = { kind: 'pdp', colors: cs, cur: cur, home: cur, homeList: homeList };
        buildPal(); label();
      }).catch(function () { if (LB.host === host && !LB.pal) LB.box.classList.remove('haspal'); });
    }
  }
  function buildPal() {
    var p = LB.pal;
    LB.box.querySelector('#lbsw').innerHTML = p.colors.map(function (c, i) {
      var name = c.n + (c.oos ? ', sold out' : '');
      return '<button type="button" class="lbchip' + (c.oos ? ' oos' : '') + '" data-lb-color="' + i + '" aria-pressed="false" aria-label="' + esc(name) + '" title="' + esc(name) + '" style="background:' + esc(c.hex) + '">'
        + (c.hex2 ? '<span class="lbchip__stripe" style="background:' + esc(c.hex2) + '"></span>' : '') + '</button>';
    }).join('');
    LB.box.querySelector('#lbpal').hidden = false; LB.box.classList.add('haspal');
    paintPal();
  }
  /* the chips stay put and only change state, so a keyboard user's focus stays on the chip just chosen */
  function paintPal() {
    var p = LB.pal, c = p.colors[p.cur];
    [].forEach.call(LB.box.querySelectorAll('.lbchip'), function (b, i) { var on = i === p.cur; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    LB.box.querySelector('#lbpalname').textContent = c.n;
    LB.box.querySelector('#lbcount').setAttribute('data-name', c.n);   /* sideways phones show it on the count line (lp-tokens.css) */
    /* on a product page the link keeps its room even on the page's own colour (invisible and inert there), so
       the strip never jumps under the shopper's finger from one colour to the next */
    var go = LB.box.querySelector('#lbgo'), away = p.kind === 'pdp' && p.cur !== p.home;
    go.hidden = p.kind !== 'pdp'; go.classList.toggle('idle', !away);
    go.textContent = 'see ' + c.n + ' \u203a';
    if (away) go.setAttribute('href', sizeUrl(c)); else go.removeAttribute('href');
  }
  function pickColor(i) {
    var p = LB.pal; if (!p || i === p.cur || i < 0 || i >= p.colors.length) return;
    var list;
    if (p.kind === 'shelf') { LB.host.pick('c', i, null); list = LB.host.lpViews().list; }   /* the shelf's own wipe runs behind the viewer */
    else { var c = p.colors[i]; list = i === p.home ? p.homeList : (c.pics && c.pics.length ? c.pics : [c.img]); }
    list = (list || []).filter(Boolean); if (!list.length) return;
    p.cur = i; LB.list = list.slice(); LB.i = 0; paintPal(); label(); keepEntry();
    /* the chip and the name change at once, the photo once it is decoded (see PICK_HOLD); an arrow pressed in the
       meantime, or a later pick, wins */
    var seq = ++PICKSEQ, was = LB.img.getAttribute('src'), L = LB.list, done = false;
    var chip = LB.box.querySelector('[data-lb-color="' + i + '"]');
    var go = function () {
      if (done) return; done = true;
      if (seq !== PICKSEQ || !isOpen() || LB.list !== L) return;
      if (LB.img.getAttribute('src') === was) wipeIn(L[0], chip, function () { if (seq === PICKSEQ && isOpen() && LB.list === L) show(0); });
      aheadFrom(L);
    };
    fetchOne(L[0], true, go, true); setTimeout(go, PICK_HOLD);
  }
  /* The colour change wipes in the way the shelf's does: a circle opening from the swatch, with the shelf's own --wipe
     duration and easing, instead of cutting straight to the new photo (Luke, 30 Sep 2026: "the rate of the animation
     when switching colors got increased and I don't like it"). The new photo is laid over the old one and clipped;
     when the circle has opened, the viewer's own image takes the new photo and the overlay goes. An arrow, a swipe,
     another colour or closing ends it at once. Reduced motion: the cut, as before. */
  var WIPE = null;
  function lbWipeMs() {
    try { var v = getComputedStyle(document.documentElement).getPropertyValue('--wipe').trim(), n = parseFloat(v); if (!n) return 1750; return v.indexOf('ms') > -1 ? n : n * 1000; }
    catch (e) { return 1750; }
  }
  function endWipe() {
    if (!WIPE) return; var w = WIPE; WIPE = null; clearTimeout(w.t);
    try { if (w.anim) w.anim.cancel(); } catch (e) {}
    if (w.el.parentNode) w.el.parentNode.removeChild(w.el);
  }
  function wipeIn(src, chip, done) {
    endWipe();
    var old = LB.img, r = old.getBoundingClientRect(), reduce = false;
    try { reduce = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    if (reduce || !old.animate || !r.width || !chip) { done(); return; }
    var c = chip.getBoundingClientRect(), ox = Math.round(c.left + c.width / 2 - r.left), oy = Math.round(c.top + c.height / 2 - r.top);
    var far = Math.ceil(Math.max(Math.hypot(ox, oy), Math.hypot(r.width - ox, oy), Math.hypot(ox, r.height - oy), Math.hypot(r.width - ox, r.height - oy)));
    var el = document.createElement('img'); el.alt = ''; el.className = 'lbwipe'; el.src = src;
    el.style.cssText = 'position:absolute;left:' + old.offsetLeft + 'px;top:' + old.offsetTop + 'px;width:' + old.offsetWidth + 'px;height:' + old.offsetHeight + 'px;object-fit:contain;pointer-events:none;z-index:1;';
    old.parentNode.appendChild(el);
    var dur = lbWipeMs(), t = null, anim = null;
    var fin = function () { if (!WIPE || WIPE.el !== el) return; WIPE = null; clearTimeout(t); done(); if (el.parentNode) el.parentNode.removeChild(el); };
    try {
      anim = el.animate([{ clipPath: 'circle(0px at ' + ox + 'px ' + oy + 'px)' }, { clipPath: 'circle(' + far + 'px at ' + ox + 'px ' + oy + 'px)' }],
        { duration: dur, easing: 'cubic-bezier(.42,.06,.26,1)', fill: 'forwards' });
      anim.onfinish = fin;
    } catch (e) { if (el.parentNode) el.parentNode.removeChild(el); done(); return; }
    t = setTimeout(fin, dur + 250);
    WIPE = { el: el, anim: anim, t: t };
  }
  /* 30 Sep 2026 — the viewer's photos, fetched ahead. Luke: "It takes nearly two seconds to scroll between
     images ... This only occurs when you switch to a color that wasn't there on load and then scroll through
     them." A colour picked here showed its first photo while it was still downloading (1600px, 50-550 KB) and
     each arrow or swipe after it waited for another download; so did every arrow in a viewer just opened.
     Now the photo on screen stays until the new colour's first one is decoded (at most PICK_HOLD); and once
     the photo showing is on screen (a colour just picked, or the viewer just opened) the others come one at a
     time, the ones either side first (high priority), then onward (low); resting the mouse on a chip, or
     touching it, starts its first photo before the click. Still the full 1600px: the viewer zooms to 2.4x.
     PICK_HOLD, PICKSEQ, CHIPT and AHEAD are declared at the top of this file. */
  function aheadFrom(L) {
    var im = LB.img, done = false;
    var go = function () {
      if (done) return; done = true;
      im.removeEventListener('load', go); im.removeEventListener('error', go);
      if (L !== LB.list || !isOpen()) return;
      AHEAD.list = L; if (!AHEAD.busy) pumpAhead();
    };
    if (im.complete) go(); else { im.addEventListener('load', go); im.addEventListener('error', go); setTimeout(go, PICK_HOLD); }
  }
  /* decode: cb waits for the decode too, so the photo can go on screen without a blank frame (only for the photo
     about to show: a decoded 1600px photo holds about 8 MB of memory) */
  function fetchOne(u, hi, cb, decode) {
    if (!u) { if (cb) cb(); return; }
    AHEAD.got[u] = 1;
    var im = new Image();
    try { im.fetchPriority = hi ? 'high' : 'low'; } catch (e) {}
    im.onload = function () { im.onload = im.onerror = null; if (!cb) return; if (decode && im.decode) im.decode().then(cb, cb); else cb(); };
    im.onerror = function () { im.onload = im.onerror = null; if (cb) cb(); };
    im.src = u;
    AHEAD.kept.push(im); if (AHEAD.kept.length > KEEP_N) AHEAD.kept.shift();
  }
  /* one at a time, nearest the photo showing: next, previous, then onward (re-read at each step, so the arrows steer it) */
  function pumpAhead() {
    AHEAD.busy = false;
    var L = LB.list, n = L.length;
    if (!isOpen() || L !== AHEAD.list || n < 2) return;
    var here = LB.img.getAttribute('src'), u = null, hi = false, order = [1, -1];
    for (var k = 2; k < n - 1; k++) order.push(k);
    order.some(function (d) { var c = L[(((LB.i + d) % n) + n) % n]; if (c && c !== here && !AHEAD.got[c]) { u = c; hi = d === 1 || d === -1; return true; } return false; });
    if (!u) return;
    AHEAD.busy = true;
    fetchOne(u, hi, pumpAhead, false);
  }
  /* the first photo of the colour under the pointer */
  function warmColor(i) {
    var p = LB.pal; if (!p || i === p.cur || !p.colors[i]) return;
    var c = p.colors[i], u = (p.kind === 'pdp' && i === p.home) ? (p.homeList || [])[0] : ((c.pics && c.pics[0]) || c.img);
    if (u && !AHEAD.got[u]) fetchOne(u, true);
  }
  function stripChip(e) { var t = e.target; return t && t.closest ? t.closest('[data-lb-color]') : null; }
  /* keep the size: the other colour's variant whose title the chosen size chip carries ("large · 5.4″ × 8.4″") */
  /* ...unless that size is sold out in the other colour: then its first size in stock, or just its page (live review, 1 Oct
     2026: Midnight Black pocket, sold out, opened on "sold out"; the shelf's own pick() does the same move) */
  function sizeUrl(c) {
    var chip = LB.host && LB.host.querySelector('[data-variant-pick].on');
    var t = chip ? chip.textContent.toLowerCase() : '', v = null, vs = c.variants || [];
    if (t) vs.some(function (x) { var n = String(x.title || '').toLowerCase(); if (n && t.indexOf(n) > -1) { v = x; return true; } return false; });
    if (v && v.available === false) { v = null; vs.some(function (x) { if (x.available) { v = x; return true; } return false; }); }
    return c.url + (v ? '?variant=' + v.id : '');
  }
  /* the viewer's own history entry becomes the other colour's page, so Back from there returns to this
     product with no dead entry in between */
  function goColor(e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;   /* a new tab or window: the browser's own business */
    var href = LB.box.querySelector('#lbgo').getAttribute('href'); if (!href) return;
    e.preventDefault();
    var replace = onEntry();
    /* the viewer stays up until the next page replaces it: closing it first showed this page again for as long
       as the other colour took to load, as if the tap had gone back (review, 30 Sep 2026); the pageshow handler
       above closes it if this page is ever restored from the back/forward cache */
    LB.opener = null;
    if (replace) location.replace(href); else location.href = href;
  }
  var SIB = {};
  function siblings(host) {
    var link = host.querySelector('a.dlink[href^="/collections/"]');   /* "back to the inspire collection" */
    var url = link && link.getAttribute('href').split('#')[0]; if (!url) return Promise.resolve(null);
    if (SIB[url]) return SIB[url];
    var key = 'lpViewerShelf1:' + url;
    try { var hit = sessionStorage.getItem(key); if (hit) return (SIB[url] = Promise.resolve(JSON.parse(hit))); } catch (e) {}
    var here = handle(location.pathname);
    SIB[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); }).then(function (html) {
      var re = /<script[^>]*\sdata-shelf[^>]*>([\s\S]*?)<\/script>/g, m, d = null;
      while ((m = re.exec(html))) {
        var j = null; try { j = JSON.parse(m[1]); } catch (err) { j = null; }
        if (j && j.colors && j.colors.some(function (c) { return handle(c.url) === here; })) { d = j; break; }
      }
      if (!d) return null;
      var slim = { colors: d.colors.map(function (c) {
        var vs = c.variants || [];
        return { n: c.n, hex: c.hex, hex2: c.hex2, url: c.url, oos: !!c.oos || (vs.length > 0 && !vs.some(function (v) { return v.available; })),
          pics: (c.pics || []).filter(Boolean), img: c.img || null, variants: vs.map(function (v) { return { id: v.id, title: v.title, available: v.available }; }) };
      }) };
      try { sessionStorage.setItem(key, JSON.stringify(slim)); } catch (err) {}
      return slim;
    });
    SIB[url].catch(function () { delete SIB[url]; });
    return SIB[url];
  }

  /* 2 Oct 2026: the product page's photographs now come in the size the page draws them at (a srcset; a phone
     gets 960px of a square frame where it used to get 1400px). The viewer zooms to 2.4x and sizes itself to the file,
     so it keeps the 1400px file it always opened: the page names it in data-zoom, and an image without one is
     read as before, the file it is showing. */
  function full(x) { return x.getAttribute('data-zoom') || x.currentSrc || x.src; }
  /* which images belong to the gallery the user clicked */
  function galleryListFor(el) {
    var host = el.closest && el.closest('lp-shelf, [data-lp-gallery]');
    if (host && typeof host.lpViews === 'function') { var v = host.lpViews(); if (v && v.list && v.list.length) return { list: v.list, i: v.i, host: host }; }
    if (host) { var imgs = host.querySelectorAll('img.zoomable, [data-lp-frame] img'); if (imgs.length) return { list: [].map.call(imgs, full), i: Math.max(0, [].indexOf.call(imgs, el)), host: host }; }
    var src = el.tagName === 'IMG' ? full(el) : '';
    return { list: src ? [src] : [], i: 0, host: null };
  }
  document.addEventListener('click', function (e) {
    var byKey = e.detail === 0;   /* Enter or Space on a focused control; a tap or click counts at least one */
    var main = e.target.closest && e.target.closest('.magwrap .zoomable');
    if (main) { var g = galleryListFor(main); open(g.list, g.i, g.host, main, byKey); return; }
    /* PHONES: the big .magwrap image is hidden below 820px, so the only photographs on screen are the
       swipe carousel's thumbnails and, on the stack layout, the stacked frames — which left no way at all
       to enlarge a product photograph on a phone (found 18 Sep 2026). The prototype bound its thumb strips
       for exactly this reason. Not bound on desktop, where clicking a thumbnail swaps the main image. */
    var phone = false;
    try { phone = window.matchMedia && matchMedia('(max-width:820px)').matches; } catch (err) {}
    /* The stacked product-page photos open the viewer at every width: a phone held sideways (844px) or a tablet has
       no hover magnifier, and on a laptop a click on them did nothing, so the viewer and its Back button were phone-only
       (preview review and Luke, 30 Sep 2026: "on the laptop site details page, there's no back button"). Only the
       stacked photos: a gallery thumbnail still swaps the main image above 820px, as before. */
    if (!phone && !(e.target.closest && e.target.closest('.psfig img'))) return;
    var img = e.target.closest && e.target.closest('.gthumbs img, .psfig img');
    if (!img) return;
    var strip = img.closest('.gthumbs, .pdpstack');
    if (!strip) return;
    var imgs = Array.prototype.slice.call(strip.querySelectorAll('img'));
    var list = imgs.map(full);
    open(list, Math.max(0, imgs.indexOf(img)), img.closest('lp-pdp, [data-lp-gallery]'), img, byKey);
  }, true);
  function gestures() {
    var im = LB.img, drag = false, sx = 0, sy = 0, ox = 0, oy = 0, pinch = 0, startZ = 1;
    im.addEventListener('click', function (e) { e.stopPropagation(); if (LB.z > 1) { LB.z = 1; LB.tx = 0; LB.ty = 0; } else { LB.z = 2.4; } apply(); });
    im.addEventListener('mousedown', function (e) { if (LB.z <= 1) return; e.preventDefault(); drag = true; sx = e.clientX; sy = e.clientY; ox = LB.tx; oy = LB.ty; });
    window.addEventListener('mousemove', function (e) { if (!drag) return; LB.tx = ox + (e.clientX - sx); LB.ty = oy + (e.clientY - sy); apply(); });
    window.addEventListener('mouseup', function () { drag = false; });
    var t0x = 0, t0y = 0, moved = 0;
    im.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) { pinch = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY); startZ = LB.z; }
      else if (e.touches.length === 1) { t0x = e.touches[0].clientX; t0y = e.touches[0].clientY; moved = 0; ox = LB.tx; oy = LB.ty; }
    }, { passive: true });
    im.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && pinch) {
        var d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
        LB.z = Math.max(1, Math.min(4, startZ * (d / pinch))); apply(); if (e.cancelable) e.preventDefault();
      } else if (e.touches.length === 1) {
        var dx = e.touches[0].clientX - t0x, dy = e.touches[0].clientY - t0y; moved = Math.abs(dx) + Math.abs(dy);
        if (LB.z > 1) { LB.tx = ox + dx; LB.ty = oy + dy; apply(); if (e.cancelable) e.preventDefault(); }
      }
    }, { passive: false });
    im.addEventListener('touchend', function (e) {
      if (pinch && e.touches.length === 0) { pinch = 0; if (LB.z <= 1.02) { LB.z = 1; LB.tx = 0; LB.ty = 0; apply(); } return; }
      if (LB.z <= 1 && moved > 60) { var dx = (e.changedTouches[0].clientX - t0x); if (Math.abs(dx) > 50) lbNav(dx < 0 ? 1 : -1); }
    });
  }

  /* desktop hover magnifier — waits out a hover-intent delay so a passing cursor doesn't trigger it */
  var MAG_DELAY = 650, MAG_ZOOM = 2.5;
  (function magnifier() {
    var fine = window.matchMedia ? window.matchMedia('(hover:hover) and (pointer:fine)') : { matches: false };
    var cur = null, timer = null;
    function paint(wrap, e) {
      var img = wrap.querySelector('.zoomable'), lens = wrap.querySelector('.maglens');
      if (!img || !lens) return false;
      var r = img.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      if (x < 0 || x > 1 || y < 0 || y > 1) return false;
      var nw = img.naturalWidth || r.width, nh = img.naturalHeight || r.height;
      var fit = getComputedStyle(img).objectFit || 'fill', bw, bh;
      if (fit === 'contain' || fit === 'cover') {
        var s = (fit === 'contain') ? Math.min(r.width / nw, r.height / nh) : Math.max(r.width / nw, r.height / nh);
        bw = nw * s * MAG_ZOOM; bh = nh * s * MAG_ZOOM;
      } else { bw = r.width * MAG_ZOOM; bh = r.height * MAG_ZOOM; }
      lens.style.backgroundImage = 'url("' + img.currentSrc + '")';
      lens.style.backgroundSize = bw + 'px ' + bh + 'px';
      lens.style.backgroundPosition = (x * 100) + '% ' + (y * 100) + '%';
      return true;
    }
    function reset() { if (timer) { clearTimeout(timer); timer = null; } if (cur) { cur.classList.remove('magon'); cur.classList.remove('magwaiting'); cur = null; } }
    document.addEventListener('mousemove', function (e) {
      if (!fine.matches) return;
      if (!cur && e.target.tagName !== 'IMG' && !e.target.closest) return;
      var wrap = e.target.closest ? e.target.closest('.magwrap') : null;
      if (!wrap) { reset(); return; }
      if (wrap !== cur) {
        reset(); cur = wrap; cur.classList.add('magwaiting');
        if (!paint(wrap, e)) { reset(); return; }
        timer = setTimeout(function () { if (cur === wrap) { wrap.classList.remove('magwaiting'); wrap.classList.add('magon'); } }, MAG_DELAY);
        return;
      }
      if (!paint(wrap, e)) reset();
    });
    document.addEventListener('mouseleave', function (e) { if (e.target && e.target.closest && e.target.closest('.magwrap')) reset(); }, true);
    window.addEventListener('blur', reset);
  })();
})();
